import { css } from "@/utils/css";

export function Center({ children, className = "" }: React.PropsWithChildren<React.HTMLProps<HTMLDivElement>>) {
    return <div className={css("center", className)}>{children}</div>;
}
